import { DEFAULT_CURRENCY, GaV4CartItem } from 'utils/analytics/clients/ga-v4-client';

type Product = {
  id: string;
  name?: string | null;
  Name?: string | null;
  type: string;
  subcategory?: string | null;
  brand?: { name?: string | null } | null;
  brandName?: string | null;
  Options?: (string | null)[] | null;
  Prices?: (number | string | null)[] | null;
};

type CartItemLike = {
  product: Product;
  option?: string | null;
  quantity?: number;
  unitPrice?: number;
  basePrice?: number | string;
  price?: number | string;
  trackerSource?: string | null;
};

/** Resolve price from product Options/Prices arrays based on selected option */
function resolveGaV4Price(item: CartItemLike): number | undefined {
  if (item.unitPrice != null) return item.unitPrice;

  if (item.basePrice != null) {
    const parsed = parseFloat(String(item.basePrice));
    if (!Number.isNaN(parsed)) return parsed;
  }

  if (item.price != null && typeof item.price === 'number') return item.price;

  const { product } = item;
  if (item.option && product.Options?.length && product.Prices?.length) {
    const idx = product.Options.indexOf(item.option);
    if (idx >= 0 && product.Prices[idx] != null) {
      const parsed = parseFloat(String(product.Prices[idx]));
      if (!Number.isNaN(parsed)) return parsed;
    }
  }

  if (product.Prices?.[0] != null) {
    const parsed = parseFloat(String(product.Prices[0]));
    if (!Number.isNaN(parsed)) return parsed;
  }

  return undefined;
}

/** Convert a cart item (CartItem instance or raw add-to-cart payload) to GA4 format */
export const cartItemToGaV4CartItem = (cartItem: CartItemLike): GaV4CartItem => ({
  ...productToGaV4CartItem(cartItem.product),
  itemCategory2: cartItem.product.subcategory ?? '',
  itemVariant: cartItem.option ?? cartItem.product.Options?.[0] ?? '',
  itemBrand: cartItem.product.brand?.name ?? cartItem.product.brandName ?? '',
  quantity: cartItem.quantity ?? 1,
  price: resolveGaV4Price(cartItem),
  currency: DEFAULT_CURRENCY,
  itemListName: cartItem.trackerSource,
});

/** Convert a raw product to GA4 item format (used for view_item before it's in the cart) */
export const productToGaV4CartItem = (product: Product): GaV4CartItem => ({
  itemId: product.id,
  itemName: product.name ?? product.Name ?? '',
  itemCategory: product.type,
  itemCategory2: product.subcategory ?? '',
  itemBrand: product.brand?.name ?? product.brandName ?? '',
  itemVariant: product.Options?.[0] ?? '',
  quantity: 1,
  price: product.Prices?.[0] != null ? parseFloat(String(product.Prices[0])) : undefined,
  currency: DEFAULT_CURRENCY,
});
